module.exports = __webpack_public_path__ + "img/splash.4bda864f.jpg";